import baseRoute from '../baseRoute';

export default `${baseRoute}/billingCode` as const;
